module.exports = __webpack_public_path__ + "static/icon-ef1a3a2631413ae23e2f35d2b9a2b4d0.png";